import { Platform } from "react-native";
import DefaultPreference from "react-native-default-preference";
import Storage from "./storage/StorageFunctions";
import Constants from "./Constants";
import { LOGIN_ROUTE } from "../../src/navigation/NavigationConstants";
import Config from "react-native-config";
import Auth0 from "../../src/components/authProvider/Auth0";
import { Logger, setAnimationLoaded } from "./HelperFunctions";
import { deleteDeviceToken } from "../api/user";
import { store } from "../store/Store";
import { resetUser } from "../store/slices/UserSlice";
import { resetPolicies } from "../store/slices/PolicySlice";
import { resetPolicyDetail } from "../store/slices/PolicyDetailSlice";
import { abortApiCall } from "./Helpers";

export const clearSessionAndLogout = async (navigation: any, logout: any) => {
  abortApiCall();
  const deviceToken = await Storage.getData(
    Constants.LocalStoreConstant.DEVICE_TOKEN,
  );
  await deleteDeviceToken(deviceToken);
  await Storage.clearAll();
  if (Platform.OS != "web") {
    DefaultPreference.clearAll();
  }

  if (logout && Platform.OS == "web") {
    logout({
      logoutParams: { returnTo: window?.location?.origin, true: true },
    });
  } else {
    if (Platform.OS === "android") {
      setTimeout(()=>{
        if (Auth0) {
          const auth0Credentials = {
            domain: Config.REACT_APP_EXZEO_ID_DOMAIN ?? "",
            clientId: Config.REACT_APP_EXZEO_ID_CLIENT_ID ?? "",
          };
          let auth0 = new (Auth0 as any)(auth0Credentials);
          auth0.webAuth
            .clearSession()
            .then(() => {})
            .catch((error: any) => Logger(error));
        }
      },10)
    }
    if (Platform.OS == "web") {
      setAnimationLoaded(false);
    }
    navigation.navigate(LOGIN_ROUTE, true);
    store.dispatch(resetUser());
    store.dispatch(resetPolicies());
    store.dispatch(resetPolicyDetail());
  }
};

export const handleInvalidTokenCase = (
  isInternetConnected: boolean | null,
  navigation: any,
  logout: () => void,
  showInternetAlert: () => void,
) => {
  if (isInternetConnected == null || isInternetConnected) {
    clearSessionAndLogout(navigation, logout);
  } else {
    showInternetAlert();
  }
};
